if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.cartCount = this.dataset.cartItemCount || '';
      this.exclusiveItem = this.dataset.exclusive ? this.dataset.exclusive.split(",").map(item => parseInt(item, 10)) : false;
      this.exclusiveLimit = this.dataset.exclusiveLimit ? this.dataset.exclusiveLimit : false;
      this.exclusiveAllow = this.dataset.exclusiveAllowOtherItems || false;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.handleFormsWithinDrawer();
    }
    

    addDelegatedClickListeners() { 
      this.addEventListener('click', (e) => {
        const anchor = e.target.closest('[href][data-product-id][data-position]');
        if (!anchor) return;
        e.preventDefault();     

        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.RecommendationProductClicked,
          data: {
            productID: anchor.dataset.productId,
            position: Number(anchor.dataset.position) + 1,
            sourceProductID: this.productId
          }
        }); 
        
        window.location.href = anchor.href;
      });
      
      window.addEventListener('click', (e) => {
        if (window.location.pathname === this.cartUrl) return;
        
        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            if (window.__attentive) { window.__attentive.hide() }
            this.open();
            return;
        }
        if (e.target.closest('[data-nav-item]') && this.cartModalOpen) {
          if (window.__attentive) { window.__attentive.show() }
          this.close(true);
          return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            if (window.__attentive) { window.__attentive.show() }
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && !e.target.closest('[data-quickbuy-action]') && !e.target.closest('[data-persist-overlay]') && this.cartModalOpen) {
            if (window.__attentive) { window.__attentive.show() }
            this.close();
            return;
        }
      });

      window.addEventListener('submit', (e) => {
        if (window.location.pathname === this.cartUrl) return;
        const productForm = e.target.closest('[action="/cart/add"]');
        if(!productForm) return;

        e.preventDefault();

        let selling_plan = null;
        if (productForm.querySelector('[name="selling_plan"]') && productForm.querySelector('[name="selling_plan"]').value !== undefined) selling_plan = productForm.querySelector('[name="selling_plan"]').value;

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('select[name="id"]').value;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]:not([disabled])');
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
            const val = input.value;

            properties[key] = val;
          }
        }

        this.classList.add('loading');
        this.addToCart(idToAdd, selling_plan, discount, properties).then(res => {
          if (!this.cartCount) {
            this.querySelectorAll('[data-empty-state]').forEach((el) => {el.style.display = 'none'})
            this.querySelectorAll('[data-cart-recs]').forEach((el) => {el.style.display = 'none'})
          }
          this.updateCartHtml().then(this.open()).then(() => this.classList.remove('loading')).finally(() => trapFocus(this));
        });

      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('button[data-cart-action="updateQty"]');
        if (!clickedElement) return;

        const {
          lineItemId,
          quantity = Number(quantity),
        } = clickedElement.dataset;
        const scrollTop = this.querySelector('form').scrollTop;

        this.classList.add('loading');
        this.updateQty(lineItemId, Number(quantity))
          .then((res) => {
            this.updateCartHtml().then(() => {
              this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
            }).finally(() => {
              this.classList.remove('loading')
              if (!this.cartCount) {
                this.querySelectorAll('[data-empty-state]').forEach((el) => {el.removeAttribute('style')})
              }
            });
          });
      })

      this.addEventListener('change', (e) => {
        const clickedElement = e.target.closest('select[data-cart-action="updateQty"]');
        if (!clickedElement) return;

        const {
          lineItemId,
        } = clickedElement.dataset;
        const quantity = clickedElement.value;
        const scrollTop = this.querySelector('form').scrollTop;

        this.classList.add('loading');
        this.updateQty(lineItemId, Number(quantity))
          .then((res) => {
            if (!this.cartCount) {
              this.querySelectorAll('[data-empty-state]').forEach((el) => {el.style.display = 'block'})
            }
            this.updateCartHtml().then(() => {
              this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
            }).finally(() => {
              this.classList.remove('loading')
              if (!this.cartCount) {
                this.querySelectorAll('[data-empty-state]').forEach((el) => {el.removeAttribute('style')})
              }
            });
          });
      })

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-mini-target]');
        if (!clickedElement) return;
    
        const targetId = clickedElement.dataset.miniTarget;
        const menu = document.querySelector(`[data-mini-menu="${targetId}"]`);
        const isAlreadyOpen = clickedElement.classList.contains('open');
    
        document.querySelectorAll('[data-mini-menu]').forEach(menu => menu.classList.add('hidden'));
        document.querySelectorAll('[data-mini-target]').forEach(button => button.classList.remove('open'));
    
        if (!isAlreadyOpen) {
            menu.classList.remove('hidden');
            clickedElement.classList.add('open');
        }
      });

      this.addEventListener('change', (e) => {
        const clickedElement = e.target.closest('[data-cart-action="updateSize"]');
        if (!clickedElement) return;

        const {
          lineItemId,
          quantity = Number(quantity),
        } = clickedElement.dataset;

        const variantId = clickedElement.value

        const scrollTop = this.querySelector('form').scrollTop;
        this.classList.add('loading');
        this.updateQty(lineItemId, 0).then((res) => {
          this.addToCart(variantId, null, null, null, quantity, true, true)
            .then((res) => {
              this.updateCartHtml().then(() => {
                this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
              });
            }).finally(() => this.classList.remove('loading'));
        });
      })

      this.addEventListener('change', (e) => {
        const clickedElement = e.target.closest('[data-cart-action="updateColor"]');
        if (!clickedElement) return;

        const {
          lineItemId,
          quantity = Number(quantity),
        } = clickedElement.dataset;

        const variantId = clickedElement.value

        const scrollTop = this.querySelector('form').scrollTop;
        this.classList.add('loading');
        this.updateQty(lineItemId, 0).then((res) => {
          this.addToCart(variantId, null, null, null, quantity, false, true)
            .then((res) => {
              this.updateCartHtml().then(() => {
                this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
              }).finally(() => this.classList.remove('loading'));
            });
        });
      })
    }

    open() {
      this.click();
      this.cartModalOpen = true;
      this.classList.remove('translate-x-[100vw]')
      this.classList.add('modal-visible')
      
      document.body.classList.add('nav-open', 'overlay')
      this.updateCartHtml();
      this.toggleAppWidgetVisibilityOff();
      const custommodalv2 = document.querySelector('custom-modalv2');
      custommodalv2.close();
     
      
    }

    close(isNav) {
      this.cartModalOpen = false;
      this.classList.add('translate-x-[100vw]');
      this.classList.remove('modal-visible');
      if (!isNav) document.body.classList.remove('nav-open', 'overlay');
      document.querySelector(`[href="${this.cartUrl}"]`).focus();
      this.toggleAppWidgetVisibilityOn();
    }

    checkForCartLimit(lineId, qty, updateQty = false) {
      let currentTotal = 0;
      let existingQty = 0;
      this.cart.items.forEach(item => {
        currentTotal += item.quantity;
        if (item.id == lineId) existingQty = item.quantity;
      });
      let projectedTotal;
      if (updateQty) {
        projectedTotal = currentTotal - existingQty + qty;
      } else if (existingQty > 0) {
        projectedTotal = currentTotal + qty;
      } else {
        projectedTotal = currentTotal + qty;
      }
      return projectedTotal <= cartLimit;
    }

    checkExclusive(id, exclusiveLimit, exclusiveAllow, newQuantity, atc) {
      const exclusiveItemsInCart = this.cart.items.filter(item => this.exclusiveItem.includes(item.id)).reduce((total, item) => total + item.quantity, 0);
      const isItemExclusive = this.exclusiveItem.includes(parseInt(id));
      const currentItem = this.cart.items.find(item => item.id === parseInt(id));
      const currentQuantity = currentItem ? currentItem.quantity : 1;
      const updatedExclusiveItemsInCart = newQuantity === 1 && atc ? exclusiveItemsInCart + 1 + (currentQuantity === 0 ? 1 : 0) : exclusiveItemsInCart - currentQuantity + newQuantity;
    
      if (isItemExclusive) {
        if (!exclusiveAllow && this.cart.items.length > 0 && !exclusiveItemsInCart) {
          window.dispatchEvent(new CustomEvent('modal:openById', {
            detail: 'exclusive-in-cart'
          }));
          return false;
        }
        if (updatedExclusiveItemsInCart > exclusiveLimit) {
          window.dispatchEvent(new CustomEvent('modal:openById', {
            detail: 'exclusive-x-only'
          }));
          return false;
        }
      } else if (!exclusiveAllow && exclusiveItemsInCart > 0) {
        window.dispatchEvent(new CustomEvent('modal:openById', {
          detail: 'exclusive-in-cart'
        }));
        return false;
      }
      return true;
    }
    
    handleFormsWithinDrawer() {
      // handle tiles within this drawer
      [...this.querySelectorAll('form[action="/cart/add"]')].forEach(form => {
        const atc = form.querySelector('button');
        form.setAttribute('action', '');
        form.addEventListener('submit', (e) => e.preventDefault());

        atc.addEventListener('click', () => {
          const idToAdd = form.querySelector('select[name="id"]').value;
          this.classList.add('loading');
          this.addToCart(idToAdd)
            .then(res => {
              if(!res) return;
              
              this.updateCartHtml(res);
              form.scrollIntoView();
            })
            .finally(() => this.classList.remove('loading'));
        })
      })
      this.classList.remove('loading');
    }
    
    toggleAppWidgetVisibilityOn() {
      const attentiveOverlay = document.getElementById('attentive_overlay');
      const driftFrameController = document.getElementById('drift-frame-controller');
      
      if (attentiveOverlay) {
        attentiveOverlay.style.zIndex = '2147483647 !important';
      }
      if (driftFrameController) {
        driftFrameController.style.zIndex = '2147483647 !important';
      }
    }
    
    toggleAppWidgetVisibilityOff() {
      const attentiveOverlay = document.getElementById('attentive_overlay');
      const driftFrameController = document.getElementById('drift-frame-controller');

      if (attentiveOverlay) {
        attentiveOverlay.style.zIndex = 999;
      }
      if (driftFrameController) {
        driftFrameController.style.zIndex = 999;
      }
    }

    async addToCart(id, selling_plan = null, discount = null, properties, quantity = 1, sizeUp = false, bypass = false) {
      if(this.exclusiveItem && !sizeUp) {
        if(!this.checkExclusive(id, this.exclusiveLimit, this.exclusiveAllow, quantity, true)) return false
      }
      if (!bypass && !this.checkForCartLimit(id, quantity)) {
        alert(`Due to high demand and shortages, we can not process orders with more than ${cartLimit} units. Please adjust your cart. For more assistance, please contact customer service.`);
        return false;
      }
      
      const data = {
        id,
        'quantity': quantity,
        sections: [`${this.sectionId}`],
        sections_url: "/cart"
      };

      if (properties && Object.keys(properties).length !== 0) {
        data['properties'] = properties;
        if (discount) data['properties']['Discount'] = discount;
      }

      if (selling_plan) data['selling_plan'] = selling_plan;

      const cartContents = fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => response.json())
        .finally(() => {
          window.FastSimonSDK.event({
            reportAppType: "MPA",
            eventName: window.FastSimonEventName.AddToCartPerformed,
            data: {
              productID: id // (Required)
            }
          });
        })
        .catch(function(err) {
          console.error(err)
        });

      return cartContents;
    }

    async updateCartHtml(res) {
      let newHtml;
      if (res) {
        newHtml = res?.sections?.[`${this.sectionId}`];
      } else {
        await fetch(`?${this.sectionId}`).then(res => {
          return res.text();
        }).then((text) => {
          newHtml = text;
        })
      }
      
      if (!newHtml) {
        console.error('Cart: unable to fetch new cart markup.');
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      if (!tempDiv.querySelector('mini-cart')?.innerHTML) return;
      //this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;
      if (this.querySelector('.dynamic-stickytop')) { this.querySelector('.dynamic-stickytop').innerHTML = tempDiv.querySelector('mini-cart .dynamic-stickytop').innerHTML; }
      
      
      this.cartCount = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [
        ...document.querySelectorAll('[data-cart-count]'),
        ...Array.from(document.querySelectorAll('template[data-modal-content="mobile-menu"]')).flatMap(template => {
          const deepQuery = (root) => {
            const matches = [...root.querySelectorAll('[data-cart-count]')];
            root.querySelectorAll('*').forEach(el => {
              if (el.shadowRoot) matches.push(...deepQuery(el.shadowRoot));
            });
            return matches;
          };
          return deepQuery(template.content);
        })
      ].forEach(cartCount => {
        cartCount.innerHTML = this.cartCount > 0 ? this.cartCount : '0';
      });
      
      if (document.querySelector('.dynamic-items')) { 
        if (this.cartCount > 0) { 
          document.querySelector('.dynamic-items').classList.remove('hidden'); 
        } else {
          document.querySelector('.dynamic-items').classList.add('hidden'); 
        }
        document.querySelector('.dynamic-items').innerHTML = tempDiv.querySelector('mini-cart .dynamic-items').innerHTML; 
      }
      if (document.querySelector('.dynamic-summary')) { document.querySelector('.dynamic-summary').innerHTML = tempDiv.querySelector('mini-cart .dynamic-summary').innerHTML; }
      if (document.querySelector('.dynamic-sticky')) { 
        if (this.cartCount > 0) { 
          document.querySelector('.dynamic-sticky').classList.remove('hidden'); 
        } else {
          document.querySelector('.dynamic-sticky').classList.add('hidden'); 
        }
        document.querySelector('.dynamic-sticky').innerHTML = tempDiv.querySelector('mini-cart .dynamic-sticky').innerHTML; 
      }
      if (document.querySelector('.dynamic-buttons')) { 
        if (this.cartCount > 0) { 
          document.querySelector('.additional-checkout-buttons')?.classList.remove('hidden'); 
          document.querySelectorAll('.dynamic-empty').forEach(el => el.classList.add('hidden')); 
        } else {
          document.querySelector('.additional-checkout-buttons')?.classList.add('hidden'); 
          document.querySelectorAll('.dynamic-empty').forEach(el => el.classList.remove('hidden')); 
        }
      }
      

      if (!this.querySelector('[data-checkout-buttons]')) return;
      const observer = new MutationObserver(observerCallback.bind(this));
      observer.observe(this.querySelector('[data-checkout-buttons]'), { childList: true, subtree: true });
      
      function observerCallback(mutationList, observer) {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            document.getElementById('AmazonPayButton')?.closest('li')?.remove();
            document.querySelector('.paypalLight')?.closest('li')?.classList.add('paypal-wrapper');
          }
        }
      }
      
      this.handleFormsWithinDrawer();
      return;
    }
    
    async updateQty(id, qty) {
      if(this.exclusiveItem && qty > 0) {
        if(!this.checkExclusive(id, this.exclusiveLimit, this.exclusiveAllow, qty, false)) return false
      }
      if (!this.checkForCartLimit(id, qty, true)) {
        alert(`Due to high demand and shortages, we can not process orders with more than ${cartLimit} units. Please adjust your cart. For more assistance, please contact customer service.`);
        return;
      };
      
      const updates = {};
      updates[id] = qty;

      const data = {
        updates,
        sections: [`${this.sectionId}`],
        sections_url: "/cart",
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };
  }

  customElements.define('mini-cart', MiniCart);
}
